import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'
import checkCircle from './images/check-circle-solid.svg'
import i18n from './translations/i18n';

let DavronFormSubmissionPage = props => {
	return (
		<div>
			<CSSTransitionGroup
				transitionName="davron"
				transitionEnterTimeout={500}
				transitionLeaveTimeout={300}
			>
			
				<div className="text-center">
					<img src={checkCircle} alt="check-circle" className="check-circle"/>
					<div>
						<h1 className="mt-5 mb-3">{i18n.t('submission_page.main_text', {lng: props.lng})}</h1>
						<h2>{i18n.t('submission_page.secondary_text', {lng: props.lng})}</h2>
						<h6>{i18n.t('submission_page.reference_name', {lng: props.lng})}</h6>
						<h6>{props.opportunity}</h6>
					</div>
					<div className="mt-5">
						<a href="https://davrontranslations.com" target="_blank" rel="noopener noreferrer" className="btn btn-orange btn-large">{i18n.t('submission_page.button', {lng: props.lng})}</a>
					</div>

				</div>

			</CSSTransitionGroup>
		</div>
	)
}

export default DavronFormSubmissionPage;


// WEBPACK FOOTER //
// ./src/DavronFormSubmissionPage.js